// Loader-data plumbing kept out of -catalogue-progressive so the statically
// bundled route definitions do not pull the catalogue pending UI (and the
// boneyard skeleton code it drags in) into the entry chunk. The lazy route
// components import -catalogue-progressive instead.
/** Keep route loaders streaming while React Query remains the data owner. */
export const createDeferredCatalogueLoaderData = (initialListPromise: Promise<unknown>) => ({
  initialListPromise,
});
